import { alpha, Box, Container, Stack, Typography, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import UpToDateCourseDetailsSection from "./component/UpToDateCourseDetailsSection";
import UpToDateCourseHero from "./component/UpToDateCourseHero";
import { getUpToDateSkillsetCourse } from "./util/course";

export default function UpToDateSkillsetTrainingCourse() {
  const theme = useTheme();
  const { courseId } = useParams();
  const course = getUpToDateSkillsetCourse(courseId);

  if (!course) {
    return (
      <Box sx={{ minHeight: 1, bgcolor: "background.default", py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <Typography variant="h3" color="primary.contrastText">
            Course not found
          </Typography>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: 1,
        bgcolor: "background.default",
        backgroundImage: `
          radial-gradient(ellipse 58% 22% at 22% 5%, ${alpha(theme.palette.info.main, 0.1)} 0%, ${alpha(theme.palette.info.main, 0)} 76%),
          radial-gradient(ellipse 50% 18% at 12% 47%, ${alpha(theme.palette.info.dark, 0.09)} 0%, ${alpha(theme.palette.info.dark, 0)} 74%),
          radial-gradient(ellipse 56% 24% at 92% 93%, ${alpha(theme.palette.info.light, 0.16)} 0%, ${alpha(theme.palette.info.main, 0.06)} 42%, ${alpha(theme.palette.info.main, 0)} 76%),
          linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.72)} 0%, ${theme.palette.background.default} 18%, ${
          theme.palette.background.default
        } 74%, ${
          theme.palette.background.default
        } 100%)
        `,
        backgroundSize: "100% 100%, 100% 100%, 100% 100%, 100% 100%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
        <Stack spacing={0}>
          <UpToDateCourseHero course={course} />
          <UpToDateCourseDetailsSection course={course} />
        </Stack>
      </Container>
    </Box>
  );
}
